import { defineAsyncComponent } from "vue";

const __USE_DUMMY__ = (__DEV__ ? false : false) as boolean;

const InitializePage =
  __PUBLIC_CLOUD__ === true && __USE_DUMMY__ !== true
    ? defineAsyncComponent(() => import("./PublicCloud.vue"))
    : defineAsyncComponent(() => import("./Dummy.vue"));

export { InitializePage };
